var _fetchStaticHtml = null;
function setFetchStaticHtml(fn) {
  _fetchStaticHtml = fn;
}
function getFetchStaticHtml() {
  return _fetchStaticHtml;
}
export {
  getFetchStaticHtml,
  setFetchStaticHtml
};
//# sourceMappingURL=staticHtmlFetcher.js.map
